"use client"

import React, { memo } from "react";

const SectionLayout = ({ children, sidebar }) => {
    return (
        <div className="grid w-full grid-cols-1 lg:grid-cols-[minmax(0,1fr)_300px] gap-5 lg:gap-8 items-start">
            <div className="section-stack min-w-0 w-full max-w-none">
                {children}

                {sidebar && (
                    <div className="lg:hidden w-full min-w-0 space-y-5 mt-5">
                        {sidebar}
                    </div>
                )}
            </div>

            {sidebar && (
                <div className="hidden lg:block w-full min-w-0 space-y-5">
                    {sidebar}
                </div>
            )}
        </div>
    );
};

export default memo(SectionLayout);
